import * as React from "react"

function AddChart(props) {
  return (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7.5 31.5C6.675 31.5 5.96875 31.2063 5.38125 30.6188C4.79375 30.0313 4.5 29.325 4.5 28.5V7.5C4.5 6.675 4.79375 5.96875 5.38125 5.38125C5.96875 4.79375 6.675 4.5 7.5 4.5H21V7.5H7.5V28.5H28.5V15H31.5V28.5C31.5 29.325 31.2063 30.0313 30.6188 30.6188C30.0313 31.2063 29.325 31.5 28.5 31.5H7.5ZM10.5 25.5H13.5V15H10.5V25.5ZM16.5 25.5H19.5V10.5H16.5V25.5ZM22.5 25.5H25.5V19.5H22.5V25.5ZM25.5 13.5V10.5H22.5V7.5H25.5V4.5H28.5V7.5H31.5V10.5H28.5V13.5H25.5Z" fill="#D7DEE6" />
    </svg>

  )
}

export default AddChart
